<template>
  <v-app>
    <div id="header">
      <div class="bg-overlay"></div>
      <v-toolbar flat dark fixed v-bind:class="{ 'scrolled elevation-3': scrolled }">
        <v-toolbar-title flatclass="headline text-uppercase">
          <span @click="window.scrollTo(0,0)">Mchain</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat href="#challenges">Desafios</v-btn>
          <v-btn flat href="#profiles">Perfiles</v-btn>
          <v-btn flat href="#prizes">Premios</v-btn>
          <v-btn flat href="#agenda">Agenda</v-btn>
          <v-btn flat href="#location">Lugar</v-btn>
          <!--v-btn flat href="#faq">FAQ</v-btn-->
          <v-btn flat href="#faq"><v-icon>help</v-icon></v-btn>
          <v-btn flat href="https://www.meetup.com/es-ES/blockchainmarbella/events/262707296/" target="_blank">Inscríbete</v-btn>
          <!--v-btn flat>EN</v-btn-->
        </v-toolbar-items>
      </v-toolbar>
      <div class="home-header">
        <!--svg class="mb-3" version="1.1" x="0px" y="0px" height="220px" viewBox="0 0 692.271 692.271" enable-background="new 0 0 692.271 692.271"
        xml:space="preserve">
        <g>
          <g>
            <path fill-rule="evenodd" clip-rule="evenodd" fill="transparent" stroke="#ffffff" d="M0,346.135C0,154.966,154.966,0,346.135,0
            s346.135,154.966,346.135,346.135S537.305,692.271,346.135,692.271S0,537.305,0,346.135z"/>
          </g>
          <polygon fill-rule="evenodd" clip-rule="evenodd" fill="transparent" stroke="#ffffff" points="147.397,168.927 147.397,237.657 91.916,237.657 
          91.916,293.967 147.397,293.967 147.397,339.511 91.916,339.511 91.916,395.82 147.397,395.82 147.397,521.687 227.721,521.687 
          227.721,345.216 345.307,513.406 462.894,345.216 462.894,521.687 543.217,521.687 543.217,395.82 598.698,395.82 598.698,339.511 
          543.217,339.511 543.217,293.967 598.698,293.967 598.698,237.657 543.217,237.657 543.217,168.927 486.436,168.927 
          344.131,370.928 204.178,168.927   "/>
        </g>
        </svg-->
        <v-container>
          <v-layout d-flex align-center justify-space-between row wrap>
            <v-flex xs12 md6>
              <h1 class="home-title">Hackathon<br>Blockchain<br>Marbella</h1>
              <div class="pt-5 home-desc">
                <p>Diseña cambios para los ciudadanos y para las ciudades, mediante el uso de tecnologías innovadoras como el Blockchain y la IA.</p>
                <p class="mb-5"><strong>6 y 7 de Julio. Marbella, Spain</strong></p>
                <v-btn round large color="blue" dark class="lighten-1" href="https://www.meetup.com/es-ES/blockchainmarbella/events/262707296/" target="_blank">Inscríbete ya</v-btn>
              </div>
            </v-flex>
            <v-flex md6 hidden-sm-and-down>
              <img src="/home-image.png" class="home-image" />
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <!--v-flex xs12>
          <v-img
          :src="require('./assets/logo.svg')"
          class="my-5"
          contain
          height="250"
          ></v-img>
        </v-flex>
        <div class="js-bounty"></div-->
      <div class="waves-container">
        <svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" class="wave wave1">
          <defs></defs>
          <path id="feel-the-wave-1" d="" />
        </svg>
        <svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" class="wave wave2">
          <defs></defs>
          <path id="feel-the-wave-2" d="" />
        </svg>
        <svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" class="wave wave5">
          <defs></defs>
          <path id="feel-the-wave-5" d="" />
        </svg>
        <svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" class="wave wave3">
          <defs></defs>
          <path id="feel-the-wave-3" d="" />
        </svg>
        <svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" class="wave wave4">
          <defs></defs>
          <path id="feel-the-wave-4" d="" />
        </svg>
        <div class="waves-desc">
          <div>El I Hackathon Blockchain Marbella del 6 al 7 de julio de 2019 se celebrará en Marbella y los participantes tendrá 24 horas para colaborar con expertos de ideas afines y partes interesadas en tecnologías de contabildad distribuida, Blockchain, Smart Contracts, Tokens y Smart Cities para desarrollar soluciones que puedan generar cambios para los ciudadanos y en los destinos turísticos inteligentes.</div>
          <div>El hackathon tiene cuatro desafíos diferentes que enfrentar, depende del participante decidir a cuál de ellos se enfrentará.
          </div>
        </div>
      </div>
    </div>
    <section id="challenges" class="bg-light">
      <v-container fluid px-0 py-0>
        <v-layout row align-center justify-content-center class="section-title">
          <v-flex xs4 sm6 text-xs-right><img src="./assets/goal.svg"></v-flex>
          <v-flex xs8 sm6 tag="h1">Los desafios</v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 class="challenge challenge1">
            <strong>Movilidad</strong>
            <p>Mejora cómo se mueven las personas, la experiencia mientras se realiza el movimiento, los servicios que se derivan...</p>
          </v-flex>
          <v-flex xs12 sm12 md6 class="challenge challenge2">
            <strong>Innovación Social</strong>
            <p>Crea modelos de colaboración, resuelve problemas sociales, ayuda a colectivos desfavorecidos, tercera edad, víctimas de malos tratos...</p>
          </v-flex>
          <v-flex xs12 sm12 md6 class="challenge challenge3">
            <strong>Digitalización Urbana</strong>
            <p>Optimiza cómo se comunica la ciudad con sus habitantes, como recibe información de ellos, ofrece experiencias relevantes en contextos físicos o virtuales...</p>
          </v-flex>
          <v-flex xs12 sm12 md6 class="challenge challenge4">
            <strong>Turismo sostenible</strong>
            <p>Consigue una producción y consumo responsables, reduce la emisión de gases, protege los entornos y a la vida submarina, optimiza las cadenas de suministro...</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section id="profiles">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 md6>
          </v-flex>
          <v-flex xs12 md6>
            <v-layout row align-center justify-content-center class="section-title" pb-4>
              <v-flex xs6 sm4 text-xs-right><img src="./assets/programmer.svg"></v-flex>
              <v-flex xs6 sm8 tag="h1" white--text>Perfiles</v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 white--text style="background:#743FEE" pa-5 class="subheading">
                • Desarrolladores<br>
                • Diseñadores <br>
                • Ingenieros <br>
                • Expertos en negocios <br>
                • Fabricantes
              </v-flex>
              <v-btn round large color="blue" dark class="lighten-1" style="margin:-20px 0 0 60px;" href="https://www.meetup.com/es-ES/blockchainmarbella/events/262707296/" target="_blank">Inscríbete ya</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section id="prizes">
      <v-container pa-0>
        <v-layout row align-center justify-content-center class="section-title">
          <v-flex xs4 sm6 text-xs-right><img src="./assets/winner.svg"></v-flex>
          <v-flex xs8 sm6 tag="h1">Los premios</v-flex>
        </v-layout>
        <v-layout row wrap text-xs-center title>
          <v-flex xs12 sm4 mb-5>
            <img src="./assets/prize1.svg" style="height:80px;" class="ma-3 flex">
            <h2>100,000 MAR</h2>
          </v-flex>
          <v-flex xs12 sm4 mb-5>
            <img src="./assets/prize2.svg" style="height:80px;" class="ma-3 flex">
            <h2>25,000 MAR</h2>
          </v-flex>
          <v-flex xs12 sm4 mb-5>
            <img src="./assets/prize3.svg" style="height:80px;" class="ma-3 flex">
            <h2>5,000 MAR</h2>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section id="agenda" class="bg-light">
      <v-container pa-0>
        <v-layout row align-center justify-content-center class="section-title">
          <v-flex xs4 sm6 text-xs-right><img src="./assets/timetable.svg"></v-flex>
          <v-flex xs8 sm6 tag="h1">Agenda</v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 px-5 pb-4>
            <h3 class="pb-3">Sábado 6 Julio</h3>
            <p>09:00 Apertura</p>
            <p>10:00 Bienvenida e introducción</p>
            <p>10:30 Lanzamiento de ideas</p>
            <p>11:00 Formación de equipos</p>
            <p>13:00 Almuerzo</p>
            <p>14:00 La creación continúa</p>
            <p>20:00 Cena</p>
          </v-flex>
          <v-flex xs12 sm12 md6 px-5 pb-4>
            <h3 class="pb-3">Domingo 7 Julio</h3>
            <p>09:00 Apertura</p>
            <p>09:30 Desayuno</p>
            <p>12:30 Fin del código y presentación</p>
            <p>13:00 Deliberaciones del jurado</p>
            <p>13:30 Anuncio de ganadores</p>
            <p>14:00 Fin del hackathon</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section id="location">
      <v-container fluid pa-0>
        <v-layout row align-center justify-content-center class="section-title">
          <v-flex xs4 sm6 text-xs-right><img src="./assets/place.svg"></v-flex>
          <v-flex xs8 sm6 tag="h1">Lugar</v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 style="background:#F4F4F4">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12829.09617533197!2d-4.9975539!3d36.4992464!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x87b3533633dc83d8!2sWe+Cowork!5e0!3m2!1sen!2ses!4v1561716815964!5m2!1sen!2ses" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section id="business" class="bg-light">
      <v-container pa-0 row text-xs-center>
        <v-layout class="section-title">
          <v-flex tag="h2" class="grey--text">GRACIAS A</v-flex>
        </v-layout>
        <v-layout row wrap align-center justify-content-center>
            <img src="./assets/logos.svg" class="mxa-3 flex">
        </v-layout>
      </v-container>
    </section>
    <section id="faq">
      <v-container>
        <v-layout row align-center justify-content-center class="section-title">
          <v-flex xs4 sm6 text-xs-right><img src="./assets/faq.svg" style="height:60px;"></v-flex>
          <v-flex xs8 sm6 tag="h1">Preguntas</v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 class="subheading">
            <h3>&iquest;Cu&aacute;l es el reto?</h3>
            <p>Podr&aacute;s crear cualquier idea y desarrollo relacionado con la movilidad, la ciudades y sus ciudadanos.</p>
            <h3>Este es mi primer hackathon, &iquest;puedo participar?</h3>
            <p>Si, no requerimos ninguna experiencia previa para asistir al hackathon.</p>
            <h3>&iquest;Necesito un equipo para asistir?</h3>
            <p>No, no necesitas un equipo y no necesitas conocer a nadie.</p>
            <h3>&iquest;C&oacute;mo se forman los equipos?</h3>
            <p>Los equipos se pueden formar antes de tiempo, si vienes al hackathon con personas que conoces o en el mismo hackathon.</p>
            <h3>&iquest;Cu&aacute;l es el tama&ntilde;o del equipo permitido?</h3>
            <p>Los equipos pueden tener de 2 a 6 miembros. No importa la cantidad de compa&ntilde;eros de equipo, asegurate de cubrir todos los roles: desarrollo, dise&ntilde;o (UI / UX), negocios y exposici&oacute;n.</p>
            <h3>&iquest;Qu&eacute; equipo necesitar&eacute; para el hackathon?</h3>
            <p>Un port&aacute;til, el cargador y cualquier otro hardware que desees utilizar.</p>
            <h3>&iquest;D&oacute;nde me puedo registrar?</h3>
            <p><a href="https://www.meetup.com/es-ES/blockchainmarbella/events/262707296/" target="_blank">REGISTRATE AQU&Iacute;</a></p>

          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <v-footer dark height="auto">
      <v-layout>
        <v-flex xs12 text-xs-center pa-5>
          &copy;2019 — <strong>Mchain</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>
<script>
import {
  wavify
} from "./wavify";
//import bounty from "bounty";
//import Vivus from "vivus";
import qrcode from 'qrcode'
import VueClipboard from 'vue-clipboard2'

export default {
  name: 'App',
  components: {
    'clipboard': VueClipboard
  },
  data: () => ({
    icons: [
      'fab fa-facebook',
      'fab fa-twitter',
      'fab fa-google-plus',
      'fab fa-linkedin',
      'fab fa-instagram'
    ],
    scrolled: false,

    address: 'add',
    qr: '',
    qrOptions: {
      errorCorrectionLevel: 'Q',
      width: '200',
      margin: 2,
      color: {
        dark: '#000000',
        light: '#fafafa'
      }
    }
  }),
  sockets: {
    connect() {
      console.log('socket connected')
      this.$socket.emit('subscribe', 'marbellachain')
    },
    'marbellachain/block': function(data) {
      //const self = this;
      //console.log(data)
    },
    'marbellachain/tx': function(data) {
      //const self = this;
      //console.log(data)
    }
  },
  methods: {
    drawQrCode() {
      //qrcode.toDataURL(`marbellachain:${this.address}?amount=${this.amount}&message=${this.message}`, this.qrOptions, (err, url) => {
      qrcode.toDataURL(this.address, this.qrOptions, (err, url) => {
        this.qr = url
      })
    },
    onCopy() {

    },
    onError() {

    },
    gradientify() {
      // target to give background to
      var $div = document.querySelector("#gradient");
      // rgb vals of the gradients
      var gradients = [{
        start: [0, 153, 191],
        stop: [30, 41, 58]
      }, {
        start: [0, 153, 191],
        stop: [234, 92, 68]
      }, {
        start: [0, 153, 191],
        stop: [130, 105, 151]
      }];

      // how long for each transition
      var transition_time = 4;

      // internal type vars
      var currentIndex = 0; // where we are in the gradients array
      var nextIndex = 1; // what index of the gradients array is next
      var steps_count = 0; // steps counter
      var steps_total = Math.round(transition_time * 60); // total amount of steps
      var rgb_steps = {
        start: [0, 0, 0],
        stop: [0, 0, 0]
      }; // how much to alter each rgb value
      var rgb_values = {
        start: [0, 0, 0],
        stop: [0, 0, 0]
      }; // the current rgb values, gets altered by rgb steps on each interval
      var prefixes = ["-webkit-", "-moz-", "-o-", "-ms-", ""]; // for looping through adding styles
      var div_style = $div.style; // short cut to actually adding styles
      var color1, color2;

      // sets next current and next index of gradients array
      function set_next(num) {
        return (num + 1 < gradients.length) ? num + 1 : 0;
      }

      // work out how big each rgb step is
      function calc_step_size(a, b) {
        return (a - b) / steps_total;
      }

      // populate the rgb_values and rgb_steps objects
      function calc_steps() {
        for (var key in rgb_values) {
          if (rgb_values.hasOwnProperty(key)) {
            for (var i = 0; i < 3; i++) {
              rgb_values[key][i] = gradients[currentIndex][key][i];
              rgb_steps[key][i] = calc_step_size(gradients[nextIndex][key][i], rgb_values[key][i]);
            }
          }
        }
      }

      // update current rgb vals, update DOM element with new CSS background
      function updateGradient() {
        // update the current rgb vals
        for (let key in rgb_values) {
          if (rgb_values.hasOwnProperty(key)) {
            for (let i = 0; i < 3; i++) {
              rgb_values[key][i] += rgb_steps[key][i];
            }
          }
        }

        // generate CSS rgb values
        let t_color1 = "rgb(" + (rgb_values.start[0] | 0) + "," + (rgb_values.start[1] | 0) + "," + (rgb_values.start[2] | 0) + ")";
        let t_color2 = "rgb(" + (rgb_values.stop[0] | 0) + "," + (rgb_values.stop[1] | 0) + "," + (rgb_values.stop[2] | 0) + ")";

        // has anything changed on this interation
        if (t_color1 != color1 || t_color2 != color2) {

          // update cols strings
          color1 = t_color1;
          color2 = t_color2;

          // update DOM element style attribute
          div_style.backgroundImage = "-webkit-gradient(linear, left bottom, right top, from(" + color1 + "), to(" + color2 + "))";
          for (let i = 0; i < 4; i++) {
            div_style.backgroundImage = prefixes[i] + "linear-gradient(45deg, " + color1 + ", " + color2 + ")";
          }
        }

        // we did another step
        steps_count++;

        // did we do too many steps?
        if (steps_count > steps_total) {
          // reset steps count
          steps_count = 0;
          // set new indexs
          currentIndex = set_next(currentIndex);
          nextIndex = set_next(nextIndex);
          // calc steps
          calc_steps();
        }

        if (div_style.backgroundImage.indexOf("gradient") != -1) {
          window.requestAnimationFrame(updateGradient)
        }
      }

      // initial step calc
      calc_steps();

      // go go go!
      window.requestAnimationFrame(updateGradient);
    },
    handleScroll() {
      this.scrolled = window.scrollY > 70;
    }
  },
  mounted() {
    //const _this = this;

    const color = '#fff';

    this.drawQrCode()

    wavify(document.querySelectorAll('#feel-the-wave-1'), {
      height: 70,
      bones: 5,
      amplitude: 60,
      color: color,
      speed: .20
    });
    wavify(document.querySelectorAll('#feel-the-wave-2'), {
      height: 70,
      bones: 3,
      amplitude: 50,
      color: color,
      speed: .25
    });
    wavify(document.querySelectorAll('#feel-the-wave-3'), {
      height: 70,
      bones: 5,
      amplitude: 30,
      color: color,
      speed: .50
    });
    wavify(document.querySelectorAll('#feel-the-wave-4'), {
      height: 80,
      bones: 6,
      amplitude: 30,
      color: color,
      speed: 0.50
    });
    wavify(document.querySelectorAll('#feel-the-wave-5'), {
      height: 70,
      bones: 6,
      amplitude: 30,
      color: color,
      speed: .45
    });

    /*
    bounty({
      el: '.js-bounty',
      value: '65,000 MAR',
      initialValue: '0 MAR',
      lineHeight: 1.35,
      letterSpacing: 1,
      animationDelay: 100,
      letterAnimationDelay: 100
    });
    */


    /*
    new Vivus('logo', {
      duration: 300
    }, function() {

    });
*/

    //_this.gradientify()
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style>
html,
body {
  height: 100%;
  width: 100%;
}

html {
  scroll-behavior: smooth;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Roboto', sans-serif;
}

.v-toolbar__content {
  height: 70px;
}

.home-title {
  font-size: 46px;
  line-height: 64px;
  max-width: 600px;
  margin: 0 auto;
}

.home-desc {
  color: rgba(255, 255, 255, 0.8);
  font-size: 20px;
  max-width: 600px;
  margin: 0 auto;
  text-align: left;
}

.v-toolbar {
  background: linear-gradient(135deg, rgba(39, 101, 191, 0.4) 0%, rgba(50, 94, 198, 0.2) 20%, rgba(111, 55, 237, 0.2) 70%) !important;
}

.scrolled {
  background: #2762da !important;
  background: linear-gradient(135deg, #2765bf 0%, #325ec6 20%, #6f37ed 70%) !important;
  transition: background-color 200ms linear;
  z-index: 10000;
}

#header {
  position: relative;
  background: url(/bg-people2.jpg) center center no-repeat;
  background-size: cover;
}

.bg-overlay {
  background: linear-gradient(135deg, #2765bf 0%, #325ec6 20%, #6f37ed 70%) !important;
  opacity: 0.86;
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
}

.home-header {
  position: relative;
  min-height: 60vh;
  text-align: left;
  color: #fff;
  padding-top: 130px;
}

.js-bounty {
  margin: 0 auto;
  font-size: 60px;
  font-family: Roboto;
  fill: #444;
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}

.application--wrap2 {
  background: rgba(0, 153, 191, 0.2);
}

.waves-container {
  position: relative;
  width: 100%;
  height: 500px;
}

.waves-desc {
  width: 100%;
  text-align: center;
  z-index: 1000;
  position: absolute;
  bottom: 80px;
  font-size: 18px;
  color: #666;
}

.waves-desc > div {
  max-width: 1000px;
  margin: 10px auto;
}

.wave {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}

.wave2 {
  z-index: 2;
  opacity: 0.3;
}

.wave3 {
  z-index: 3;
  opacity: 0.4;
}

.wave4 {
  z-index: 4;
  opacity: 0.3;
}

.wave5 {
  z-index: 2;
  opacity: 0.4;
}

.theme--light.application {
  background: #fff;
  color: rgba(0, 0, 0, 0.87);
}

.theme--dark.v-toolbar {
  background-color: transparent;
}

section {
  min-height: 400px;
}

#challenges {
  padding-bottom: 0;
  height: auto;
}

.challenge {
  background: #F4F4F4 url(./assets/1_.svg) 30px 30px no-repeat;
  background-size: 60px;
  padding: 50px 50px 50px 140px;
  min-height: 200px;
}

.challenge strong {
  font-size: 30px;
  margin-bottom: 20px;
  display: block;
}

.challenge p {
  color: #999;
  font-size: 16px;
}

.challenge2,
.challenge3 {
  background-color: #EBECED;
}

.challenge2 {
  background-image: url(./assets/2_.svg);
}

.challenge3 {
  background-image: url(./assets/3_.svg);
}

.challenge4 {
  background-image: url(./assets/4_.svg);
}

@media (max-width: 960px) {
  .challenge3 {
    background-color: #F4F4F4;
  }

  .challenge4 {
    background-color: #EBECED;
  }
}


#profiles {
  background: url(/534008512.jpg) center center no-repeat;
  background-size: cover;
  min-height: 500px;
}

#agenda {}

#prizes {}

#faq {}

#register {}

#logo {
  stroke-width: 4;
  fill: white;
  height: 200px;
  width: 200px;
  margin-bottom: 40px;
}

.bg-light {
  background-color: #fafbfe!important;
}

section {
  padding-top: 80px;
  padding-bottom: 80px;
  position: relative;
  border-top: 1px solid #f4f4f4;
}

.section-title {
  padding-bottom: 80px;
}

.section-title h1 {
  color: #000000;
  font-size: 40px;
  line-height: 80px;
  display: inline-block;
  position: relative;
}

.section-title h1:after {
  content: " ";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 10px;
  background-color: #1DBAFF;
}

#location {
  padding-bottom: 0;
}

.section-title img {
  height: 80px;
  margin-right: 30px;
}

#agenda .section-title img {
  width: 60px;
}

#agenda > .container {
  max-width: 900px;
  margin: 0 auto;
}

#agenda h3 {
  font-size: 20px;
}

#agenda p {
  font-size: 16px;
}


#location .section-title img {
  width: 60px;
}

.section-title-border {
  background-color: #2762da !important;
}

.section-title-border {
  width: 50px;
  height: 2px;
  margin-right: auto;
  margin-left: auto;
}

.prize-icon {
  height: 40px;
  width: 40px;
  fill: #2762da;
  margin-top: 50px;
}

.v-toolbar__title {
  background: url(./assets/logo-white.svg) left center no-repeat;
  background-size: 40px 40px;
  padding-left: 56px;
  height: 48px;
  line-height: 48px;
  font-size: 24px;
}

.home-image {
  opacity: 0.6;
  width: 100%;
  max-width: 600px;
}

.waves-desc > div {
  max-width: 80%;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .waves-container {
    min-height: 700px;
  }

}

</style>